var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "default-modal",
        {
          attrs: {
            name: "text-teplate-modal",
            title: _vm.$t("text_template_modal_title"),
            width: "md"
          },
          model: {
            value: _vm.modalOpened,
            callback: function($$v) {
              _vm.modalOpened = $$v
            },
            expression: "modalOpened"
          }
        },
        [
          _c("template", { slot: "header" }),
          _c(
            "template",
            { slot: "content" },
            [
              _c(
                "div",
                { staticClass: "flex justify-center q-mt-md" },
                [
                  _c("q-btn-toggle", {
                    attrs: {
                      "toggle-color": "dark",
                      options: [
                        {
                          label: _vm.$tc("text_template_top", 2),
                          value: "top"
                        },
                        {
                          label: _vm.$tc("text_template_bottom", 2),
                          value: "bottom"
                        }
                      ]
                    },
                    model: {
                      value: _vm.position,
                      callback: function($$v) {
                        _vm.position = $$v
                      },
                      expression: "position"
                    }
                  })
                ],
                1
              ),
              _c("text-template-form", {
                attrs: {
                  template: _vm.selected,
                  type: _vm.type,
                  model: _vm.model
                }
              }),
              _vm.templates.length > 0
                ? _c(
                    "div",
                    { staticClass: "q-pb-md" },
                    [
                      _c(
                        "q-infinite-scroll",
                        { attrs: { handler: _vm.handleInfiniteScroll } },
                        _vm._l(_vm.templates, function(template, index) {
                          return _c("text-template-entry", {
                            key: index,
                            staticClass: "q-mt-md",
                            attrs: { template: template },
                            on: {
                              apply: function($event) {
                                _vm.templateSelected(template.content)
                              },
                              edit: function($event) {
                                _vm.handleEdit(template)
                              },
                              delete: function($event) {
                                _vm.handleDelete(template)
                              }
                            }
                          })
                        })
                      )
                    ],
                    1
                  )
                : [
                    _c(
                      "div",
                      {
                        staticClass: "row justify-center items-center col-grow"
                      },
                      [
                        _c("div", { staticClass: "text-center" }, [
                          _c("img", {
                            attrs: {
                              src: require("assets/emptystates/templates_empty.svg")
                            }
                          }),
                          _c("h6", { staticClass: "q-my-md text-faded" }, [
                            _vm._v(_vm._s(_vm.$t("no_templates")))
                          ])
                        ])
                      ]
                    )
                  ]
            ],
            2
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }